import React, { Component } from 'react';
import { connect } from 'react-redux';

import Question from './Question';
import { answerSelect, updateQuestion, updateView } from 'actions';

import { move } from 'utils/array';

import './index.css';

class Quiz extends Component {
	constructor(props) {
		super(props);

		this.state = {
			orientation: ''
		}

		this.questions = [];
		this.handleAnswerClick = this.handleAnswerClick.bind(this);
	}

	handleAnswerClick(answer) {
		const { dispatch, questions, quiz: { current } } = this.props;
		// console.log('::::::::::::: answer selected', answer);
		dispatch(answerSelect(answer));
		if (current === questions.length - 1) dispatch(updateView('results'));
		else dispatch(updateQuestion({ current: current + 1, prev: current }));
		// track('click', `question: ${question.question}, answer: ${answer}`);
	}

	componentDidMount() {
		window.addEventListener('resize', () => {
			const resize = () => {
				if (setTimeout) clearTimeout(setTimeout);
				this.setState(() => ({ orientation: window.innerWidth > window.innerHeight ? 'landscape' : 'portrait' }));
			}
			const setTimeout = window.setTimeout(resize, 100);
		});
	}

	render() {
		const { view, questions, quiz } = this.props;

		return (
			<div className={`quiz content view ${view.id === 'quiz' ? 'active' : ''}`}
				ref={instance => this.questions = instance}>
				{questions.map((question, index) =>
					<Question
						question={question}
						index={index}
						quiz={quiz}
						onClick={this.handleAnswerClick}
						key={`question-${index}`} />)}
				<div className="pagination-container">
					{questions.map((question, index) => <div className={`pagination ${quiz.current === index ? 'active' : ''}`} key={`${question}-${index}`}></div>)}
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
  return {
		view: state.view,
		quiz: state.quiz
  }
}

Quiz = connect(mapStateToProps)(Quiz);
export default Quiz;



// WEBPACK FOOTER //
// ./src/components/Quiz/index.js